<app-auth-container>
  <ng-template #content>  
    <div class="col-md-10 col-12">
      <h1 class="font-weight-700">{{ "Login.COMPLETE_REGISTRATION" | translate }}</h1>  
    <p class="mb-4 " >
      {{ "Login.WELCOME_TO" | translate
      }} <a class=""> {{
        "Tenant.Company_Name" | translate
        }}</a>
    </p>
    <form #formGroup="ngForm">
      <div class="app-form-control">
        <label class="input-label" for="nationalId">{{ "Login.YOUR_IQAMA" | translate }}</label>
          <div class="w-100">
            <input type="text" class="w-100" placeholder="0000 0000 0000 0000" name="nationalId"
            id="nationalId" maxlength="10" appNumbersOnly [pattern]="nationalIdPattern" [(ngModel)]="nationalId" #nationalIdRef="ngModel" />
        </div>
        <mat-error *ngIf="nationalIdRef.errors&&nationalIdRef.errors['required']">{{ "Shared.REQUIRED" | translate }}
        </mat-error>
        <mat-error id="error_national_valid" *ngIf="nationalIdRef.errors&&nationalIdRef.errors['pattern']">
          {{ "Login.IQAMA_NOT_VALID" | translate }}
        </mat-error>
      </div>
   
      <input type="submit" value="{{ 'Shared.CONTINUE' | translate }}" class="mt-3 btn-block"
        [disabled]="!formGroup.valid" (click)="verifyInvitedUser()" />         
            </form>
          </div>
  </ng-template>
</app-auth-container>